module.exports = __webpack_public_path__ + "img/index2.c4ac8cc1.png";